"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SkipToPrevious15Sec = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_SkipToPrevious15Sec_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.646.146a.5.5 0 1 1 .708.708L1.207 3l2.147 2.146a.5.5 0 1 1-.708.707l-2.5-2.5a.5.5 0 0 1 0-.707l2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.887.146a.5.5 0 0 1 .707.708L4.947 2.5H9.25a6.75 6.75 0 0 1 0 13.5H9a.5.5 0 0 1 0-1h.25a5.75 5.75 0 0 0 0-11.5H4.947l1.647 1.646a.5.5 0 1 1-.707.707l-2.5-2.5a.5.5 0 0 1 0-.707l2.5-2.5ZM2.075 16h1.262V7H2.25L0 9.162l.7.775.838-.774c.141-.134.258-.25.35-.35.091-.1.17-.192.237-.276l-.025.538-.025.55V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.043 10.662c-.358-.225-.779-.337-1.262-.337-.183 0-.367.013-.55.038a3.464 3.464 0 0 0-.513.087l.175-2.375h2.763V7H4.818l-.287 4.188.512.4c.184-.059.384-.105.6-.138.225-.042.434-.063.625-.063.542 0 .95.142 1.225.425.275.284.413.696.413 1.238 0 .367-.067.692-.2.975a1.462 1.462 0 0 1-.563.662c-.241.15-.541.226-.9.226a3.49 3.49 0 0 1-.95-.138c-.316-.1-.608-.23-.875-.388v1.188c.242.142.521.246.838.313.317.075.667.112 1.05.112.625 0 1.15-.12 1.575-.363.425-.25.746-.6.962-1.05.225-.458.338-.991.338-1.6 0-.541-.1-1.008-.3-1.4a2.1 2.1 0 0 0-.838-.925Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_SkipToPrevious15Sec_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = SkipToPrevious15Sec;
exports["default"] = _default;